import React from 'react';
import FormSelect from 'shared/forms/FormSelect';
import { useGetPorts } from 'src/fetch/ports';
import { emptyArray } from 'src/shared/helpers/utils';

const PortsDropdown = (props) => {
  const { data: ports = emptyArray } = useGetPorts();
  return (
    <FormSelect
      data={props.data || ports}
      textField="portName"
      dataItemKey="id"
      {...props}
    />
  );
};

export default PortsDropdown;